import React, { useState, useContext, useEffect } from 'react';
import UserContext from '../context/UserContext';
import { apiClient } from '../api/client';
import { login } from '../api/auth';
import '../Login.css';
import minilogo from '../images/Kopia_STOCK_SLEUTH-removebg-preview-1.png';
import saly from '../images/Saly.png';
import seePass from '../images/seePassword.png';
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Link,
	NavLink,
	useParams,
	useNavigate,
  } from "react-router-dom";
import '../newstyles.css';
import { GoogleLogin } from '@react-oauth/google';
import { completeGoogleSignIn, getGoogleAuthErrorMessage } from '../api/googleAuth';

const SignIn = () => {
  const { setUser } = useContext(UserContext);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(true);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	  // If the current path is "/scanner", don't show the search bar
		useEffect(() => {
		console.log("runs");
		const handleResize = () => {
		console.log("handling");
		  const mobile = window.innerWidth <= 768;
		  setIsMobile(mobile);
		  if (mobile) {
		  console.log("mobile");
			
		  } else {
		  console.log("desktop");
		  
		}
		};
	  
		// Invoke handleResize on component mount
		handleResize();
	  
		// Add event listener for window resize
		window.addEventListener('resize', handleResize);
	  
		// Cleanup event listener on component unmount
		return () => window.removeEventListener('resize', handleResize);
	  }, []);
	

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setPasswordError('');
      await completeGoogleSignIn({ credentialResponse, persistent: rememberMe, setUser, navigate });
    } catch (error) {
      setPasswordError(error.message === 'MISSING_GOOGLE_CREDENTIAL'
        ? 'Google did not return a valid credential. Please try again.'
        : getGoogleAuthErrorMessage(error));
    }
  };





	const handleTogglePassword = () => {
		setShowPassword(!showPassword);
	};

  const handleSignIn = async (event) => {
    event?.preventDefault();
    // Password strength check
    if (password.length < 8) {
      setPasswordError('Invalid username or password');
      return;
    } else {
      setPasswordError('');
    }

    try {
      const loginData = await login({ username, password }, { persistent: rememberMe });
      const response = { data: loginData };

      const token = response.data.token;
      const userData = { ...response.data, ...response.data.username, ...response.data.image }; // Include the username

      const profileImageResponse = await apiClient.get('/auth/getpfp');

			  // Add the profile_image field to the user object
			  const updatedUser = {
          ...response.data, ...response.data.username, ...response.data.image,
				profile_image: profileImageResponse.data.profile_image,
				displayname: profileImageResponse.data.displayname,
				pronouns: profileImageResponse.data.pronouns,
				bio: profileImageResponse.data.bio,
				mod: profileImageResponse.data.mod,
				premium: profileImageResponse.data.premium,
				language: profileImageResponse.data.language
				
			  };

      setUser(updatedUser);
	  navigate("/");
    } catch (error) {
      console.error('Sign in failed', error);
	  setPasswordError('Invalid username or password');
    }
  };

  return (
    <div style = {{ textAlign: "center", alignItems: 'center',justifyContent: 'center', width: '100vw', height: '100vh', display: 'flex', background: '#FFF'}}>
		<NavLink to="/" className="logo" style={{top: 18, left:20}}>
		  <div className="overlap-5">
			<div className="text-wrapper-7">
			  StockSleuth
			</div>
			<img className="kopia-STOCK-SLEUTH" alt="Kopia STOCK SLEUTH" src={minilogo} />
		  </div>
		</NavLink>
		{!isMobile ? (<>
		<div className="AlreadyAccount">
			<h3 className="SignInTo">Sign in to</h3>
			<h4 className="YourAcc">Your StockSleuth Account</h4>
			<p className="text1">If you don’t have an account,</p>
			<p className="text2">You can <span style={{color: '#4D47C3', fontWeight: '600'}}><Link to="/SignUp" style={{color: '#4D47C3', fontWeight: '600', textDecoration: 'none'}}>Register here !</Link></span></p>
			{/*<img className="person" src={saly}/>*/}
		</div>
		<div className="signInForm">
			<h2 className = "LoginHeader" style = {{margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left'}}>Sign In</h2>
			<div className = "EmailInput">
			<input className="EmailPlaceholder2" name="username" autoComplete="username" style={{color: '#A7A3FF',padding: '0px',position: 'relative', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type="text" placeholder="Enter email or user name" value={username} onChange={(e) => setUsername(e.target.value)} />
			</div>
			<div className = "PasswordInput">
			<input className='passPlaceholder' name="password" autoComplete="current-password" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSignIn(e); }} />
			<img onClick={handleTogglePassword} style={{position: 'absolute',top: '23px', right: '32px'}} src={seePass} />
			</div>
			<Link className="forgotPassword" style={{marginTop: '17px'}} to="/ForgotPassword">Forgot password?</Link>
			<label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12 }}><input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />Remember me</label>
			{passwordError && <p style={{ color: 'black' }}>{passwordError}</p>}
			<div className="SignInButton"onClick={handleSignIn}><p className="LogIn"style={{margin: '0px'}}>Log In</p></div>
			<p className="ContinueWith">or continue with</p>
			<GoogleLogin onSuccess={handleGoogleSuccess} onError={() => setPasswordError('Google sign-in failed. Please try again.')} />{/*
			<path d="M39.4108 21.1315C39.4108 19.6402 39.2873 18.5519 39.02 17.4234H21.6434V24.1543H31.8431C31.6375 25.8271 30.5271 28.3462 28.0593 30.0389L28.0247 30.2643L33.5189 34.4354L33.8996 34.4727C37.3954 31.3086 39.4108 26.6533 39.4108 21.1315Z" fill="#4285F4"/>
			<path d="M21.6422 38.8662C26.6392 38.8662 30.8342 37.2539 33.8984 34.4728L28.0581 30.0391C26.4953 31.1072 24.3977 31.8528 21.6422 31.8528C16.748 31.8528 12.5941 28.6889 11.1133 24.3157L10.8963 24.3338L5.18338 28.6667L5.10867 28.8702C8.15212 34.7952 14.4036 38.8662 21.6422 38.8662Z" fill="#34A853"/>
			<path d="M11.1144 24.3158C10.7237 23.1873 10.4976 21.978 10.4976 20.7286C10.4976 19.479 10.7237 18.2699 11.0939 17.1414L11.0835 16.901L5.29899 12.4986L5.10973 12.5868C3.85537 15.0455 3.13562 17.8064 3.13562 20.7286C3.13562 23.6508 3.85537 26.4116 5.10973 28.8703L11.1144 24.3158Z" fill="#FBBC05"/>
			<path d="M21.6423 9.60422C25.1176 9.60422 27.4619 11.0754 28.7986 12.3048L34.0219 7.30685C30.814 4.38469 26.6393 2.59108 21.6423 2.59108C14.4037 2.59108 8.15214 6.66192 5.10867 12.5868L11.0928 17.1414C12.5941 12.7683 16.7481 9.60422 21.6423 9.60422Z" fill="#EB4335"/>
			*/}
		</div></>) : (<>

<div className="signInForm" style={{right: "auto"}}>
			<h2 className = "LoginHeader" style = {{margin: "0px", position: 'relative', left: 0, top: 0, textAlign: 'left'}}>Sign In</h2>
			<div className = "EmailInput">
			<input className="EmailPlaceholder2" name="username" autoComplete="username" style={{color: '#A7A3FF',padding: '0px',position: 'relative', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type="text" placeholder="Enter email or user name" value={username} onChange={(e) => setUsername(e.target.value)} />
			</div>
			<div className = "PasswordInput">
			<input className='passPlaceholder' name="password" autoComplete="current-password" style={{color: '#A7A3FF',padding: '0px',position: 'relative',top: '20px', left: '26px',width: '188px',height: '23px', border: 'none', background: 'none' }} type={showPassword ? 'text' : 'password'} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') handleSignIn(e); }} />
			<img onClick={handleTogglePassword} style={{position: 'absolute',top: '23px', right: '32px'}} src={seePass} />
			</div>
			<Link className="forgotPassword" style={{marginTop: '17px'}} to="/ForgotPassword">Forgot password?</Link>
			<label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 12 }}><input type="checkbox" checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />Remember me</label>
			{passwordError && <p style={{ color: 'black' }}>{passwordError}</p>}
			<div className="SignInButton"onClick={handleSignIn}><p className="LogIn"style={{margin: '0px'}}>Log In</p></div>
			<p className="ContinueWith">or continue with</p>
			<GoogleLogin onSuccess={handleGoogleSuccess} onError={() => setPasswordError('Google sign-in failed. Please try again.')} />{/*
			<path d="M39.4108 21.1315C39.4108 19.6402 39.2873 18.5519 39.02 17.4234H21.6434V24.1543H31.8431C31.6375 25.8271 30.5271 28.3462 28.0593 30.0389L28.0247 30.2643L33.5189 34.4354L33.8996 34.4727C37.3954 31.3086 39.4108 26.6533 39.4108 21.1315Z" fill="#4285F4"/>
			<path d="M21.6422 38.8662C26.6392 38.8662 30.8342 37.2539 33.8984 34.4728L28.0581 30.0391C26.4953 31.1072 24.3977 31.8528 21.6422 31.8528C16.748 31.8528 12.5941 28.6889 11.1133 24.3157L10.8963 24.3338L5.18338 28.6667L5.10867 28.8702C8.15212 34.7952 14.4036 38.8662 21.6422 38.8662Z" fill="#34A853"/>
			<path d="M11.1144 24.3158C10.7237 23.1873 10.4976 21.978 10.4976 20.7286C10.4976 19.479 10.7237 18.2699 11.0939 17.1414L11.0835 16.901L5.29899 12.4986L5.10973 12.5868C3.85537 15.0455 3.13562 17.8064 3.13562 20.7286C3.13562 23.6508 3.85537 26.4116 5.10973 28.8703L11.1144 24.3158Z" fill="#FBBC05"/>
			<path d="M21.6423 9.60422C25.1176 9.60422 27.4619 11.0754 28.7986 12.3048L34.0219 7.30685C30.814 4.38469 26.6393 2.59108 21.6423 2.59108C14.4037 2.59108 8.15214 6.66192 5.10867 12.5868L11.0928 17.1414C12.5941 12.7683 16.7481 9.60422 21.6423 9.60422Z" fill="#EB4335"/>
			*/}
			<p className="text1" style={{color: "#B5B5B5"}}>If you don’t have an account,</p>
			<p className="text2" style={{color: "#B5B5B5"}}>You can <span style={{color: '#4D47C3', fontWeight: '600'}}><Link to="/SignUp" style={{color: '#4D47C3', fontWeight: '600', textDecoration: 'none'}}>Register here !</Link></span></p>
			
		</div>
		
		</>)}
    </div>
  );
};

export default SignIn;
